import { getCountries } from "@/api/zones"
import { useZoneStore } from '@/store/modules/zone'
import { reactive } from "vue"

export const useZone = () => {
  const zoneStore = useZoneStore()
  const state = reactive({
    selectedCountries: []
  })

  const setCountries = async () => {
    if (zoneStore.regions.length > 0) return
    const res = await getCountries()
    // 将区域数据转换为所需的层级结构
    const allRegions = res.regions.map((region: any) => ({
      id: region.id,
      name: region.name,
      countries: region.countries.map((country: any) => ({
        iso2: country.iso2 || country.code,
        name: country.name,
        isEnabled: true
      }))
    }))
    zoneStore.setRegions(allRegions)
  }

  return {
    state,
    setCountries
  }
}